import {
  GET_BULK_LIST,
  GET_BULK_LIST_FAIL,
  GET_BULK_LIST_SUCCESS,
  SEND_BULK_SMS_SUCCESS,
  SEND_BULK_SMS_FAIL,
  SEND_BULK_SMS,
  SEND_QUICK_SMS,
  SEND_QUICK_SMS_FAIL,
  SEND_QUICK_SMS_SUCCESS,
  UPDATE_SENT_SMS,
  GET_BULK_LIST_DELIVERY_SUCCESS,
  GET_BULK_LIST_DELIVERY_FAIL,
  GET_BULK_DELIVERY_LIST,
  GET_BULK_SCHEDULE,
  GET_BULK_SCHEDULE_SUCCESS,
  GET_BULK_SCHEDULE_FAIL
} from "./actionTypes"

export const getBulkLists = (payload) => ({
  type: GET_BULK_LIST,
  payload
})

export const getBulkListsSuccess = bulkLists => ({
  type: GET_BULK_LIST_SUCCESS,
  payload: bulkLists,
})

export const getBulkListsFail = error => ({
  type: GET_BULK_LIST_FAIL,
  payload: error,
})

export const getBulkSchedule = (id) => ({
  type: GET_BULK_SCHEDULE,
  payload: id
})

export const getBulkScheduleSuccess = (data) => ({
  type: GET_BULK_SCHEDULE_SUCCESS,
  payload: data
})

export const getBulkScheduleFail = (error) => ({
  type: GET_BULK_SCHEDULE_FAIL,
  payload: error
})

export const getBulkDelivery = (payload) => ({
  type: GET_BULK_DELIVERY_LIST,
  payload
})

export const getBulkDeliverySuccess = bulkLists => ({
  type: GET_BULK_LIST_DELIVERY_SUCCESS,
  payload: bulkLists,
})

export const getBulkDeliveryFail = error => ({
  type: GET_BULK_LIST_DELIVERY_FAIL,
  payload: error,
})

export const updateSent = () => ({
  type: UPDATE_SENT_SMS,
})

// export const getContactListDetail = (id) => ({
//   type: GET_CONTACT_LIST_DETAIL,
//   payload: id
// })

// export const getContactListDetailSuccess = contactListDetail => ({
//   type: GET_CONTACT_LIST_DETAIL_SUCCESS,
//   payload: contactListDetail,
// })

// export const getContactListDetailFail = error => ({
//   type: GET_CONTACT_LIST_DETAIL_FAIL,
//   payload: error,
// })

export const sendBulkSMS = (payload) => ({
  type: SEND_BULK_SMS,
  payload
})

export const sendBulkSmsSuccess = bulkLists => ({
  type: SEND_BULK_SMS_SUCCESS,
  payload: bulkLists,
})

export const sendBulkSmsFail = error => ({
  type: SEND_BULK_SMS_FAIL,
  payload: error,
})

export const sendQuickSMS = (payload) => ({
  type: SEND_QUICK_SMS,
  payload
})

export const sendQuickSmsSuccess = bulkLists => ({
  type: SEND_QUICK_SMS_SUCCESS,
  payload: bulkLists,
})

export const sendQuickSmsFail = error => ({
  type: SEND_QUICK_SMS_FAIL,
  payload: error,
})


